import { Automation } from '../model/automation.model';
import { AccessPrincipal, hasPermission } from './auth';

const slugFor: Record<Automation.AccessAction, Automation.Permission> = {
  read: Automation.permissions.Read,
  write: Automation.permissions.Write,
  run: Automation.permissions.Run,
};

/**
 * @desc The one authorisation question every automations service method asks (D14): may
 * `caller` read, write or run automations?
 *
 * Answered on the permission slug for the action alone (ADR-29): `automations:read`,
 * `automations:write` or `automations:run`, carried by the `ario` role group (`ario-viewer`
 * read; `ario-operator` all three). Neither `admin:access` nor `admin:view` implies any of them,
 * so an `internal-admin` without an Ario role is refused (decision 8). The Mongo `users.roles`
 * field is never consulted: the claims come from the WorkOS token.
 */
export function canAutomate(
  caller: AccessPrincipal | null | undefined,
  action: Automation.AccessAction,
): boolean {
  return hasPermission(caller, slugFor[action]);
}
